
import axiosInstance from './Axios';


export interface User {
    key: number;
    id: string;
    first_name: string;
    last_name:string;
    email: string;
    phone: string;
    role_name: string;
    role_id: string;
    user_id: string;
    ban: boolean;
}

export interface Roles {
    role_id: string;
    role_name: string;
}

export function getUserDetailByUserId(user_id: string) {
    const params = { user_id };
    return axiosInstance
      .get<User>(`user-detail`, { params })
      .then((response) => response.data);
  }

  

  export function getCurrUserDetailByUserId() {
    return axiosInstance
      .get<User>(`curr-user-detail`)
      .then((response) => response.data);
  }

export function getUserList() {
    return axiosInstance
      .get<User[]>(`user-list`)
      .then((response) => response.data);
}

export function getUserRole() {
    return axiosInstance
      .get<Roles>(`user-role`)
      .then((response) => response.data);
}

export function getUserDiscount() {
  return axiosInstance
    .get<string>(`user-discount`)
    .then((response) => response.data);
}

export function getListRoles() {
    return axiosInstance
        .get<Roles[]>('/roles')
        .then((response) => response.data);
}

export function editUserDetailByUserId(
    user_id: string,
    data: User,
  ) {
    const params = { user_id };
    return axiosInstance
      .put<User>(`edit-users`, data, { params })
      .then((response) => response.data);
  }